<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" @hidden="hidden" id="modal-notificacion">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <span class="modal-title text-center"> <b>Enviar Notificacion</b> </span>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
               
                <form class="form-horizontal">
                    <div class="form-group">
                        <label for="inputEmail3" class="col-sm-2 control-label">Asunto: </label>
                        <div class="col-sm-10"> <input class="form-control input-sm" maxlength="50" type="text" v-model="xasunto"> </div>
                    </div>

                    <div class="form-group">
                        <label for="inputEmail3" class="col-sm-2 control-label">Mensaje: </label>
                        <div class="col-sm-10">
                            <textarea class="form-control" type="text" v-model="xbody" maxlength="190" rows="5"></textarea>
                        </div>
                    </div>
                </form>

                <div v-show="datafcm.id">
                    <p style="margin-bottom:0"> <b>Notificacion para:</b> {{datafcm.nombres}} {{datafcm.pri_apellido}} {{datafcm.seg_apellido}} </p>
                    <p> <b>Documento:</b> {{datafcm.num_doc}} </p>
                    <div>
                        <b>Dispositivos registrados:</b>
                        <p v-for="(t,ind) in fcmtokens" :key="ind" style="margin-bottom:0"> <input type="checkbox" v-model="t.activo"> {{t.uid}} ({{t.status}}) </p>
                    </div>
                </div>

                <p class="text-center text-danger"> {{msg}} </p>
                <div v-show="shownotoken">
                    <b>AVISO:</b> Este participante no tiene un token de notificacion.
                    <p>Las posibles razones son:</p>
                    <ul>
                        <li>No ha iniciado session en Esam Estudiantes Movil</li>
                        <li>No tiene habilitadas las notificaciones en Esam Estudiantes Movil</li>
                        <li>Denego el permiso de recibir notificaciones en Esam Estudiantes Movil</li>
                    </ul>
                    <p>Soluciones:</p>
                    <ul>
                        <li>El participante debe iniciar session en Esam Estudiantes Movil</li>
                        <li>El participante debe habilitar las notificaciones</li>
                        <li>Volver a intentar</li>
                    </ul>
                </div>
            </div>
            
            <Alertas ref="alertar" />
            <div v-show="loading" class="loader center-block"></div>
            <div class="modal-footer">
                <button @click="submit" :disabled="loading || !hastoken || shownotoken" type="button" class="btn btn-azul">Enviar Notificacion</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
    </div>
</template>

<style lang="css" scoped>
.loader {
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid blue; /* Blue */
  border-bottom: 4px solid blue;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1.2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>

<script>
import Alertas from '@/components/AAlertas.vue'
//import https from 'https';

    export default {
        props: { obj:{ type: Object,required: true } },
        data(){
            return{
                loading: true,
                hastoken: false,
                shownotoken: false,
                datafcm:{},
                fcmtokens:[],
                msg: null,
                xasunto: '',
                xbody: '',
            }
        },
        watch:{
            'obj.xidpersona':function(){
                window.console.log( 'PERSONASSS' );
                this.gettokennotificacionbyuid();
            }
        },
        components:{Alertas},
        methods:{
            hidden(){
                window.console.log('OCULTO MODALLL');
            },
            gettokennotificacionbyuid(){
                const vue = this;
                vue.msg = '';
                vue.datafcm = {};
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                //${this.obj.xidpersona}
                let sql = `query{ tokenEsamByuid(uid:"802-"){ id,uid,token,data,fecha,estado } }`;
                var graphql = JSON.stringify({ query: sql, variables: {} })
                var requestOptions = { method: 'POST', headers: myHeaders, body: graphql };

                fetch(process.env.VUE_APP_API_SLADIA+"/graphql/", requestOptions)
                .then(response => response.json())
                .then(result => {
                    window.console.log(result);
                    let datos = result.data.tokenEsamByuid;
                    if( datos && datos.length ){
                        vue.hastoken = true;
                        vue.shownotoken = false;
                        vue.fcmtokens = [];
                        datos.forEach(function(e){
                            if( e.data ){
                                let dat = e.data.replace(/'/g,"\"");
                                vue.datafcm = JSON.parse( dat );
                                window.console.log( "DATA:::",dat )
                            }
                            vue.fcmtokens.push( {uid:e.uid,token:e.token,status:'',activo:true} );
                        });
                    }else{
                        vue.hastoken = false;
                        vue.shownotoken = true;
                    }
                    vue.loading = false;
                })
                .catch(() => {
                    // window.console.log('error', error)
                });
            },
            submit(){
                const vue = this;
                setTimeout(function(){vue.submit2()},500);
            },
            submit2(){
                let isvalido = this.validar();
                if( !isvalido ) return;
                const vue = this;
                this.msg = '';
                this.loading = true;

                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append("Authorization", "key=AAAA_78IIKI:APA91bF48yfw4YOxJzv3dPrZQbkTZ9Ygkx0c8zvwA9nzbvJ4hfon95cpj8454lUjhOxMJpNZMiqmvMpb7RwMPoZ61NSX_j9NuiHJ1RbiHw6H0nCPrzXWhiH15Zt9XMCbSyYk210OzXsi");
                //myHeaders.append("project_id", "cyberrcorp");
                //myHeaders.append("notification_key_name", "dieguin");

                var consultas = [];
                this.fcmtokens.forEach(function(e){
                    e.status = '';
                    if( e.activo ){
                        e.status = 'Enviando...';
                        var raw = JSON.stringify({"to":""+e.token,"notification":{"title":""+vue.xasunto,"body":""+vue.xbody,"priority":"high","click_action": `${process.env.VUE_APP_DOMAIN}estudiantes`,"icon":`${process.env.VUE_APP_DOMAIN}img/logo_esam_principal.png`},"data":{"d1":1}});
                        var requestOptions = { method: 'POST', headers: myHeaders, body: raw };
                        consultas.push( 
                            fetch("https://fcm.googleapis.com/fcm/send", requestOptions)
                            .then(value => value.json())
                            .then(result => {
                                window.console.log('result',result);
                                if( result.success ) e.status = 'Enviado.';
                                else e.status = 'NO enviado.'
                            }));
                    }
                });
                if( consultas.length == 0 ){
                    this.loading = false;
                    this.msg = 'No hay dispositivos seleccionados.';
                }

                //this.guardarnotificacion( this.obj.xidpersona,this.xbody )
                this.guardarnotificacion( 802,this.xbody )

                Promise.all( consultas )
                .then(allResponses => {
                    window.console.log('allResponses',allResponses);
                    vue.loading = false;
                }).catch(() => {
                    // window.console.log('error', error);
                    vue.loading = false;
                });
            },
            guardarnotificacion( uid,sms ){
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                let sql = `
                mutation{
                    notificacionEsam(uid:"${uid}",mensaje:"${sms}"){
                        notificacion{id,uid,mensaje,fecha,visto,estado}
                    }
                }`;
                window.console.log( sql )
                var graphql = JSON.stringify({ query: sql, variables: {} })
                var requestOptions = { method: 'POST', headers: myHeaders, body: graphql };

                fetch(process.env.VUE_APP_API_SLADIA+"/graphql/", requestOptions)
                .then(response => response.json())
                .then(result => { window.console.log(result); })
                .catch(() => {
                    // window.console.log('error', error)
                });
            },
            validar(){
                var valido = true;
                if( !this.xasunto ) { this.msg = 'Falta el asunto'; valido = false }
                else if( !this.xbody ) { this.msg = 'Falta el mensaje'; valido = false }
                else if( this.fcmtokens.length == 0 ) { this.msg = 'No hay dispositvos habilitados'; valido = false }
                return valido;
            }
        },
    
    }
</script>
